import { getPhysicTakeHeaders } from '../Services';
import { IonRow, IonCol, IonLoading, useIonToast, IonItem } from "@ionic/react";
import React, { useEffect, useState } from "react";
import styles from "../Css/PhysicalTakeHeader.module.scss";
import { closeCircle } from 'ionicons/icons';

const PhysicalTakeHeader = ({ charge, fn }) => {
  const [headers, setHeader] = useState([]);
  const [data, setBody] = useState([]);
  const [loading, setLoading] = useState(false);
  const [tittle] = useState('Detalle Toma Física');
  const [initialCharge] = useState(true);
  const [present] = useIonToast();

  useEffect(() => {
    setLoading(true);
    if (!charge) {
      const headers = JSON.parse(sessionStorage.getItem('physicalTakeHeader'));
      const data = JSON.parse(sessionStorage.getItem('PhysicalTakeList'));
      setHeader(headers);
      setBody(data);
      setLoading(false);
    } else {
      const data = { status: 2 };
      getPhysicTakeHeaders(data).then((response) => {
        setLoading(false);
        if (response.status) {
          if (response.data.length > 0 && response.headers.length > 0) {
            setHeader(response.headers);
            setBody(response.data);
            sessionStorage.setItem('physicalTakeHeader', JSON.stringify(response.headers));
            sessionStorage.setItem('PhysicalTakeList', JSON.stringify(response.data));
          }
        } else {
          response.messages.map((message) => (
            present({
              message: message,
              duration: 3000,
              position: 'bottom',
              color: 'danger',
              icon: closeCircle
            })
          ));
        }
      });
    }
  }, [initialCharge, charge, present]);

  const printBody = () => {
    const rowBody = data.map((item, key) => (
      <IonItem className={styles.detail} button detail={true}  key={ key }  onClick={() => { fn('detail', tittle, item.physicTakeHeaderCode) }}>
        <IonRow>
          <IonCol size="12">
            {
              headers.map((header, keyD) => {
                return (
                  <div key={keyD} className={styles.textDetail}>
                      <b>{header.text}</b> {item[header.value]} <br></br>
                  </div>
                );
              })
            }
          </IonCol>
        </IonRow>
      </IonItem>
    ));
    return rowBody;
  }

  return (
    <div className={styles.content}>
      <IonLoading isOpen={loading} message="Cargando..." />
        {printBody()}
    </div>
  );
};

export default PhysicalTakeHeader;